import React, { useState, useEffect } from 'react';
import api from '../services/api';
import '../styles/Hierarchy.css';

const Hierarchy = () => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [managerUserId, setManagerUserId] = useState('');
  const [subordinateUserId, setSubordinateUserId] = useState('');

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    try {
      setLoading(true);
      const usersResp = await api.getUsers();
      setUsers(usersResp.data || []);
      setError('');
    } catch (err) {
      setError('Failed to load data');
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleAssign = async (e) => {
    e.preventDefault();
    if (!managerUserId || !subordinateUserId) {
      setError('Please select both manager and team member');
      return;
    }

    if (managerUserId === subordinateUserId) {
      setError('Manager and team member cannot be the same');
      return;
    }

    try {
      await api.assignUserHierarchy(managerUserId, subordinateUserId);
      setSuccess('Hierarchy assigned successfully');
      setManagerUserId('');
      setSubordinateUserId('');
      setTimeout(() => setSuccess(''), 3000);
    } catch (err) {
      setError('Failed to assign hierarchy');
    }
  };

  return (
    <div className="content-container">
      <div className="page-header-section">
        <h2 className="section-title">👥 User Hierarchy Management</h2>
        <p>Define reporting relationships between users. Managers will see data from their team members.</p>
      </div>

      {error && <div className="error-message">{error}</div>}
      {success && <div className="success-message">{success}</div>}

      <div className="hierarchy-form-card">
        <h3>Assign Reporting Relationship</h3>
        <form onSubmit={handleAssign} className="hierarchy-form">
          <div className="form-group">
            <label>Manager (Parent)</label>
            <select
              value={managerUserId}
              onChange={(e) => setManagerUserId(e.target.value)}
              required
              className="form-control"
            >
              <option value="">-- Select Manager --</option>
              {users
                .filter((u) => u.is_approved)
                .map((user) => (
                  <option key={user.id} value={user.id}>
                    {user.email} ({user.role})
                  </option>
                ))}
            </select>
          </div>

          <div className="form-group">
            <label>Team Member (Subordinate)</label>
            <select
              value={subordinateUserId}
              onChange={(e) => setSubordinateUserId(e.target.value)}
              required
              className="form-control"
            >
              <option value="">-- Select Team Member --</option>
              {users
                .filter((u) => u.is_approved && u.id !== managerUserId)
                .map((user) => (
                  <option key={user.id} value={user.id}>
                    {user.email} ({user.role})
                  </option>
                ))}
            </select>
          </div>

          <button type="submit" className="btn btn-primary" disabled={loading}>
            Assign
          </button>
        </form>
      </div>

      <div className="info-card">
        <h3>ℹ️ How It Works</h3>
        <ul>
          <li>A manager can see data from all their subordinates</li>
          <li>Subordinates cannot see manager data</li>
          <li>This creates a user-level hierarchy for data filtering</li>
          <li>Different from role hierarchy - this is person-specific</li>
        </ul>
      </div>
    </div>
  );
};

export default Hierarchy;

